import { createApp } from 'vue'
import App from './App.vue'
import axios from 'axios'
// import "../src/assets/scss/dist/css/bootstrap.min.css";
import VueApexCharts from "vue3-apexcharts";
import "bootstrap"
import "bootstrap/dist/css/bootstrap.min.css"

// import "@/assets/scss/sidebar.scss"
import "@/assets/scss/application.scss"
import "@/assets/scss/login.scss"

import router from './router/index'
import interceptor from '@/auth/inceptors'
interceptor()
createApp(App).use(router).use(VueApexCharts).mount('#app')